import { message } from "../translate.helper";

const en = {
  [message.charge_id]: "Charge ID",
  [message.purchase_details]: "Purchase details",
  [message.see_refund_policy]: "See Refund Policy",
  [message.here]: "Here",
  [message.pay_before]: "Pay before",
  [message.payment_successful]: "Payment Successful",
  [message.payment_pending]: "Payment Pending",
  [message.payment_pending_desc]: "Payment status is pending and waiting for merchant action. They will get back to you.",
  [message.payment_date]: "Payment date",
  [message.payment_method]: "Payment method",
  [message.back_to_merchant]: "Back to merchant",
  [message.save_to_files]: "Save to files",
  [message.share_to_email]: "Share to email",
  [message.mail_receipt]: "Mail the receipt",
  [message.enter_email_send_receipt]: "Enter the email to send a receipt",
  [message.email]: "Email",
  [message.cancel]: "Cancel",
  [message.send]: "Send",
  [message.receipt_sent]: "Receipt is sent",
  [message.oops_link_is_invalid]: "Oops, link is invalid!",
  [message.link_has_been_used_or_doesnt_exist]:
    "The link you’re looking for has been used or doesn’t exist",
  [message.unable_to_process_the_payment]: "Unable to process the payment",
  [message.unable_to_send_email]: "Unable to send email at the moment",
  [message.done]: "Done",
  [message.payment_has_been_finished]:
    "Your payment process has been finished, you can close the paylink now.",
  [message.please_follow_instructions_payment]:
    "Please follow the instructions below to make payment",
  [message.qr_code_desc_desktop_no_1]: "Launch your preferred bank app",
  [message.qr_code_desc_desktop_no_2]: "Scan the QR code",
  [message.qr_code_desc_desktop_no_3]: "Verify amount and authorise payment",
  [message.qr_code_desc_desktop_no_4]:
    "Page will refresh upon successful receipt of payment",
  [message.qr_code_desc_mobile_no_1]:
    "Screen shot / save the QR code to your photo gallery",
  [message.qr_code_desc_mobile_no_2]:
    'Open your preferred bank app, go to "Scan QR"',
  [message.qr_code_desc_mobile_no_3]:
    "Upload / import the QR code from album / photo gallery",
  [message.qr_code_desc_mobile_no_4]: "Verify amount and authorise payment",
  [message.qr_code_desc_mobile_no_5]:
    "Return to your checkout page on the browser / app",
  [message.qr_code_desc_mobile_no_6]:
    "Page will refresh upon successful receipt of payment",
  [message.qr_code_please_notes]: "Please note:",
  [message.qr_code_please_notes_no_1]:
    "You will be paying to Omise Payment Singapore Pte. Ltd, authorised payment processor on our behalf",
  [message.qr_code_please_notes_no_2]:
    "One QR is for one order only, please do not make multiple payments with the same QR",
  [message.download_qr_code]: "Download QR",
  [message.payment_failed]: "Payment Failed",
  [message.something_went_wrong]: "Something went wrong.",
  [message.contact_merchant]: "We’re unable to process this payment link at the moment. For any questions or further assistance, please contact the merchant directly.",
  [message.try_again]: "Try again.",

  [message.no_access_title]: "Merchant Account Unavailable",
  [message.no_access_description]: "We’re unable to process this payment link at the moment. For any questions or further assistance, please contact the merchant directly.",
  [message.npa_save_card]: "Save Card",
  [message.npa_no_charge]: "(No Charge)",
  [message.payment_processing_do_not_close]: "Don't close or refresh this page until your payment is complete.",
};

export default en;
